export const colors = {
  branco: '#f9f9f7',
  verde: '#148581',
  lilas: '#8E8FC7',
  cinza: '#4A4A4A',
  amarelo: '#ffd37d',
  laranja: '#ffbc91',
  vermelho: '#FA7373',
  verdeCategoria: '#B4DCCF',
  lilasCategoria: '#A4A5D3',
  laranjaCategoria: '#EDB582',
  amareloCategoria: '#E3D48F',
  azulGradiente: 'linear-gradient(to top, #3b338a, #0ca6e1)',
  azulGradienteReverso: 'linear-gradient(to top, #0ca6e1, #3b338a)',
  verdeGradiente: 'linear-gradient(to top, #8accb7, #006a65)',
  verdeGradienteReverso: 'linear-gradient(to top, #006a65, #8accb7)',
  verdeGradienteHorizontal: 'linear-gradient(to right, #006a65, #8accb7)',
  verdeGradienteHorizontalReverso: 'linear-gradient(to left, #006a65, #8accb7)',
  laranjaGradiente: 'linear-gradient(to bottom, #ffbc91, #fa7272)',
  laranjaGradienteReverso: 'linear-gradient(to bottom,#fa7272, #ffbc91)',
  laranjaGradienteHorizontal: 'linear-gradient(to right, #fa7272, #ffbc91)',
  laranjaGradienteHorizontalReverso:
    'linear-gradient(to left, #fa7272, #ffbc91)',
  lilasGradiente: 'linear-gradient(to top, #c3c4e8, #8e8fc7)',
  lilasGradienteReverso: 'linear-gradient(to top, #8e8fc7, #c3c4e8)',
  lilasGradienteHorizontal: 'linear-gradient(to right, #8e8fc7, #c3c4e8)',
  lilasGradienteHorizontalReverso: 'linear-gradient(to left, #8e8fc7, #c3c4e8)',
  lilasGradiente2:
    'linear-gradient(to bottom, #8e8fc7, #9899cd, #a2a3d4, #acadda, #b6b7e0, #b3b4dc, #b0b0d9, #adadd5, #9c9dc7, #8c8cba, #7c7dac, #6c6d9f)',
  inputGradiente: 'linear-gradient(to bottom, #dbdbdb, #a5a5a5)',
  amareloGradienteHorizontal: 'linear-gradient(to left, #F3CF89, #FFC553)',
  amareloGradienteHorizontalReverso:
    'linear-gradient(to right, #F3CF89, #FFC553)',
  vermelhoGradienteHorizontal: 'linear-gradient(to left, #fa7272, #E14040)',
  vermelhoGradienteHorizontalReverso:
    'linear-gradient(to right, #fa7272, #E14040)',
}
export default colors
